import React, { memo, type ReactNode } from 'react'
import tw from 'twin.macro'
import { ContractorStepDetailsReviewButton } from './buttons/ContractorStepDetailsReviewButton'
import { CollectedData } from 'src/interfaces/collectedData'

export interface ContractorStepDetailsCardActionsProps {
  actions?: ReactNode
  onReviewStepDataAction?: () => void | Promise<void>
  showReviewButtonWithText?: boolean
  collectedData?: CollectedData | null
}

const ContractorStepDetailsCardActionsComponent = ({
  actions,
  onReviewStepDataAction,
  showReviewButtonWithText = false,
  collectedData,
}: ContractorStepDetailsCardActionsProps) => {
  const reviewButton = onReviewStepDataAction && (
    <ContractorStepDetailsReviewButton
      onAction={onReviewStepDataAction}
      iconOnly={!showReviewButtonWithText}
      showReviewButtonWithText={showReviewButtonWithText}
      showDocumentIcon={!!collectedData?.lastRejectionDocuments?.length}
    />
  )

  const hasContent = reviewButton || actions

  if (!hasContent) {
    return null
  }

  return (
    <div css={tw`flex flex-wrap items-center gap-2 shrink-0 self-center`}>
      {reviewButton}
      {actions}
    </div>
  )
}

export const ContractorStepDetailsCardActions = memo(ContractorStepDetailsCardActionsComponent)
